import React, { memo } from "react";
import Label from "components/general/Label"

export const TableExpanded = memo((props) => {
    const { row, config } = props;
    let boulders = config?.filter(cfg => cfg?.code === 'BOULDER')?.sort((a, b) => a?.pos - b?.pos)?.map(i => ({ pos: i?.pos, value: i?.value }));
    boulders = Array.isArray(boulders) && boulders.length > 0 ? boulders : [{ pos: '1', value: '1' }, { pos: '2', value: '2' }, { pos: '3', value: '3' }, { pos: '4', value: '4' }];
    const out = (<table>
        <tbody>
            <tr>
                <td></td>
                <td className="text-end"><Label data='LabelTop' /></td>
                <Zones boulders={boulders} level={3} row={row} />
                <td></td>
            </tr>
            <tr className="d-none">
                <td></td>
                <td className="text-end"><Label data='LabelHighZone' /></td>
                <Zones boulders={boulders} level={2} row={row} />
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td className="text-end"><Label data='LabelLowZone' /></td>
                <Zones boulders={boulders} level={1} row={row} />
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td className="text-end"><Label data='HeaderAttempts' /></td>
                <Attempts boulders={boulders} row={row} />
                <td></td>
            </tr>
        </tbody>
    </table>)

    return <>{out}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    return false;
    //return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults);
});

const Attempts = ({ boulders, row }) => {
    const out = boulders.map(b => {
        let arrive = row?.extendedResults?.find(er => er?.er_code === 'RESULT' && er?.er_type === 'BOULDER' && er?.er_pos === b?.pos)?.er_arrive;
        return (<td key={b.pos}>{arrive}</td>)
    })
    return <>{out}</>
}

const Zones = ({ boulders, level, row }) => {
    const out = boulders.map(b => {
        let zone = row?.extendedResults?.find(er => er?.er_code === 'RESULT' && er?.er_type === 'BOULDER' && er?.er_pos === b?.pos)?.er_value2;
        let classGreen = levelToNumber(zone) >= level ? 'bg-success level' : 'level';
        return (<td className={classGreen} key={b.pos}></td>)
    })
    return <>{out}</>
}

const levelToNumber = (level) => {
    return level === 'TOP' ? 3 : level === 'HIGH' ? 2 : level == 'LOW' ? 1 : 0;
}



